import React from 'react'
import BillingHistory from "../billing-history/BillingHistory";

export default function Invoices() {
  return (
    <BillingHistory isSuperAdminView />
  )
}
